import Vue from '@vue/compat';

/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
       //分页数据
        selector: '.circle-moment-list',
        api: 'getMomentList',
        param: {
            size: 10,
            circle_id:typeof qk_circle !== 'undefined' ?qk_circle.id:0
        },
        videos: [], // 存储视频元素
        currentVideoIndex: 0, // 当前播放的视频索引
        isScrolling:false, // 用于标记是否正在滚动
        videoPlayId:'',
        tabIndex:0,
        tabType:'all',
        isDataEmpty:false,
        loading: false,
        locked:false,
        orderby:'',
        orderbyList:{
            '':'默认排序',
            'date':'发布时间',
            'comment_date':'回复时间',
            'modified':'修改时间',
            'random':'随机排序',
            'comments':'评论数最多',
            'views':'浏览数最多',
            'like':'点赞数最多',
        },
        circleList:[],
        circles:[],
        circleTabs:[],
        circleTabIndex:'all',
        pageCount:0,
        list_opt:[],
        pckry:'',
        locked:false,
    },
    mounted(){
        if(!this.$refs.circleContentWrap) return;
        
        (typeof lazyLoadInstance !== 'undefined' && lazyLoadInstance?.restoreAll ? lazyLoadInstance.restoreAll() : undefined);//将 DOM 恢复到其原始状态用于解决vue和懒加载冲突
        qkUpdateLazyLoad();
        
        this.list_opt = qk_list_opt.opts
        this.tabIndex = qk_list_opt.tabIndex

        this.updateVideoPlayer();
        this.$nextTick(() => {
            if(this.list_opt[this.tabIndex].list_style_type == 'list-3' && qkClientWidth > 768){
                this.pckry = new Packery('.circle-moment-list.qk-waterfall')
            }
            imgFancybox('[data-fancybox]',{groupAll:false})
            Tabs();
            window.addEventListener('scroll', _debounce(this.handleVideoPlay,100));
        });
    },
    computed: {
        waterfallClass() {
            if (this.list_opt[this.tabIndex] && this.list_opt[this.tabIndex].list_style_type === 'list-3' && qkClientWidth > 768 && !this.$refs.momentList.classList.contains('qk-waterfall')) {
                return 'qk-waterfall';
            }else{
                return '';
            }
        },
        playType(){
            return this.list_opt[this.tabIndex].video_play_type;
        }
    },
    methods:{
        changeTab(index,type,orderby = false) {
           
            if (this.$refs.momentList.classList.contains('qk-waterfall') && this.list_opt[index].list_style_type != 'list-3') {
                this.$nextTick(() => {
                    this.$refs.momentList.className = 'circle-moment-list';
                });
            }
            
            if(index == this.param.index && type == this.tabType && !orderby) return;
            
            if(this.locked == true) return;
            this.locked = true
            
            this.param.index = index;
            this.tabType = type;
            this.tabIndex = index;
            
            this.$refs.jsonPageNav.pageCount = 1;
            this.pageCount = 1;
            this.$refs.momentList.innerHTML = '';

            if(this.tabType != 'circle') {
                this.loading = true;
                this.isDataEmpty = false;
            }
            
            if (this.tabType == 'circle')  {
                this.locked = false;
                !this.circles.length && this.getCircles();
                return;
            }
            this.$nextTick(() => {
                this.$refs.jsonPageNav.load(1, '', true);
            });
        },
        changeOrderby(type) {
            this.param.orderby = this.orderby = type
            this.changeTab(this.param.index,this.tabType,true)
        },
        listChange(data){
            
            this.isDataEmpty = (data.data.length === 0 && !this.$refs.momentList.children.length);
            this.loading = false;
            this.locked = false;
            
            data.data.forEach((newHtml) => {
              // 创建新的Vue实例并挂载到新的div元素上
                const newVueInstance = new Vue({
                    template: newHtml,
                    data:this.$data,
                    methods: {
                        mataClick:this.mataClick,
                        setNum:this.setNum,
                        report:this.report,
                        setMomentBest:this.setMomentBest,
                        setMomentSticky:this.setMomentSticky,
                        getMomentId:this.getMomentId,
                        deleteMoment:this.deleteMoment,
                        changeMomentStatus:this.changeMomentStatus,
                    }
                }).$mount();
                
                // 给newVueInstance的根元素添加class
                newVueInstance.$el.classList.add('is-visible');
                // 将新的Vue实例的根元素追加到moment-list中
                this.$refs.momentList.appendChild(newVueInstance.$el);
            });
            
            imgFancybox('[data-fancybox]',{groupAll:false})
            
            this.$nextTick(() => {
                //this.pckry && this.pckry.destroy(); //导致瀑布流加载滚回顶部
                
                if(this.list_opt[this.tabIndex].list_style_type == 'list-3'){
                    qkClientWidth > 768 && (this.pckry = new Packery('.circle-moment-list.qk-waterfall'))
                }else{
                    this.pckry && this.pckry.destroy(); //导致瀑布流加载滚回顶部
                }
                
                this.updateVideoPlayer()
            });

            if(this.pageCount == 1){
                this.$scrollTo('.circle-scroll-to', 0, {offset: -56});//easing: 'ease-in'
            }

            this.pageCount = 0;
        },
        getCircles() {
            this.loading = true;
            this.$https.post(qk_rest_url+'getAllCircles').then(res=>{
                this.circles = res.data.list;
                this.circleTabs = res.data.cats;
                this.circleList = res.data.list.slice()
                this.circleList.splice(0, 1);
                this.loading = false;
                // this.$nextTick(() => {
                //     if(this.$refs.scrollTab) {
                //         this.scroll = new BScroll(this.$refs.scrollTab, {
                //             scrollX: true,
                //             probeType: 3, // listening scroll event
                //             click:true    
                //         })
                //     }
                // });
            }).catch((err) => {
                this.loading = false;
                qkShowApiError(err, '加载圈子列表失败');
            })
        },
        circleCatChange(index) {
            this.circleTabIndex = index;
            
            if(this.circleTabIndex == 'all'){
                // 创建一个新的数组副本
                this.circleList = this.circles.slice();
                // 删除新数组的第一个元素
                this.circleList.splice(0, 1);
                return
            }
            
            if(this.circles[this.circleTabIndex].list.length) {
                this.circleList = [this.circles[this.circleTabIndex]];
            }else{
                this.circleList = []
            }
            
            // this.TabscrollTo(index);
        },
        // 控制视频播放
        handleVideoPlay() {
            if(this.playType == 'none' || this.playType == 'mouseover') return
            
            if (this.videos.length > 0) {
                let closestDistance = Infinity;
                this.videos.forEach((video, index) => {
                    const rect = video.getBoundingClientRect();
                    const distanceToTop = Math.abs(rect.top);
                    const videoElement = video.querySelector('video');
                    if (distanceToTop < closestDistance && rect.top > (-rect.height / 3 + 100) && rect.top < window.innerHeight - rect.height) {
                        closestDistance = distanceToTop;
                        this.$nextTick(()=>{
                            if(videoElement.paused && this.playType == 'scroll' && this.list_opt[this.tabIndex].list_style_type != 'list-3'){
                                let promise = videoElement.play();
                                if (promise !== undefined) {
                                    promise.then(() => {
                                        // video can play
                                    }).catch(err => {
                                        // video cannot play
                                        // 将视频设置为静音
                                        videoElement.muted = true;
                                        // 重新尝试播放
                                        videoElement.play();
                                    })
                                }
                            }
                        })
                    } else {
                        this.$nextTick(()=>{
                            !videoElement.paused && videoElement.pause();
                        })
                    }
                });
            }
        },
        updateVideoPlayer() {
            if(this.playType == 'none') return
            
            if (this.$refs.momentList) {
                this.videos = this.$refs.momentList.querySelectorAll('.moment-video-wrap');
                if(!this.videos.length) return
                
                this.videos.forEach((item,index) => {
                    const video = item.querySelector('video');
                    const videoPoster = item.querySelector('.video-poster .video-play-btn');
                    if (!video.hasListener) {
                        video.id = item.getAttribute('video-id')
                        video.addEventListener('play', () => {
                            this.videoPlayId = video.id
                            this.pauseOtherVideos(video);
                            
                            //当前播放的视频索引
                            this.currentVideoIndex = index
                        });
                        
                        video.addEventListener('pause', () => {
                            if (!video.seeking && video.id == this.videoPlayId) {
                                this.videoPlayId = ''
                            }
                        });
                        
                        if(this.playType == 'mouseover'){
                            item.addEventListener('mouseenter', () => {
                                video.paused && video.play();
                            });
                    
                            item.addEventListener('mouseleave', () => {
                                !video.paused && video.pause();
                            });
                        }
                        
                        if(this.playType == 'mouseover' || this.playType == 'click'){
                            videoPoster.addEventListener('click', () => {
                                event.preventDefault();
                                event.stopPropagation(); // 阻止事件冒泡
                                video.paused && video.play();
                            });
                        }
                        
                        video.hasListener = true;
                    }
                });
            }
        },
        pauseOtherVideos(currentVideo) {
            this.videos.forEach(item => {
                const video = item.querySelector('video');
                if (video !== currentVideo && !video.paused) {
                    video.pause();
                }
            });
        },
        //点赞
        mataClick(type){
            if(!qktoken) return this.$createModal('login');
            
            if(type == 'comment') {
                var parentElement = event.target.closest('.moment-card-inner')
                let href = parentElement.querySelector('.moment-content > a').href;
                qkCurrentPageReload(href + '#comments')
                return 
            }

            let apis = {
                like:'postVote',
                collect:'userFavorites'
            }
            
            if(this.locked == true || !apis[type]) return;
            this.locked = true
            
            let post_id = this.getMomentId(event)
            let e = event.currentTarget // 当前元素
            
            apis[type] && this.$http.post(qk_rest_url + apis[type],'post_id='+post_id).then(res=>{
                this.setNum(res.data.count,e);
                this.locked = false;
                this.$message({ message: res.data.message , type: 'success' });
            }).catch(err => {
                this.locked = false;
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        setNum(num,e){
            if(e.classList.contains('active')){
                e.classList.remove("active");
            }else{
                e.classList.add("active");
            }
            e.setAttribute('num',num)
        },
        report(){ 
            console.log(this.getMomentId(event))
            if(!qktoken) return this.$createModal('login');
            this.$createModal("report",{
                props:{
                    post_id:this.getMomentId(event)
                }
            })
        },
        setMomentBest(){
            //closest方法来获取最接近的具有指定类的父元素。closest方法会向上遍历DOM树，直到找到符合条件的元素为止
            var parentElement = event.target.closest('.moment-card-inner')
            let h2 = parentElement.querySelector('h2');
            if(!h2) {
                h2 = parentElement.querySelector('.content');
            }
            
            let post_id = this.getMomentId(event)
            
            this.$http.post(qk_rest_url + 'setMomentBest','post_id='+post_id).then(res=>{
                
                if(res.data.type) {
                    let span = document.createElement('span');
                    span.className = 'moment-best';
                    h2.insertBefore(span, h2.firstChild);
                }else{
                    let span = h2.querySelector('.moment-best');
                    if (span) {
                        h2.removeChild(span);
                    }
                }
                
                this.$message({ message: res.data.message , type: 'success' });
            }).catch(err => {
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        setMomentSticky(){
            
            //closest方法来获取最接近的具有指定类的父元素。closest方法会向上遍历DOM树，直到找到符合条件的元素为止
            var parentElement = event.target.closest('.moment-card-inner')
            let h2 = parentElement.querySelector('h2');
            if(!h2) {
                h2 = parentElement.querySelector('.content');
            }
            
            let post_id = this.getMomentId(event)
            
            this.$http.post(qk_rest_url + 'setMomentSticky','post_id='+post_id).then(res=>{
                
                if(res.data.type) {
                    let span = document.createElement('span');
                    span.className = 'moment-sticky';
                    h2.insertBefore(span, h2.firstChild);
                }else{
                    let span = h2.querySelector('.moment-sticky');
                    if (span) {
                        h2.removeChild(span);
                    }
                }
                
                this.$message({ message: res.data.message , type: 'success' });
            }).catch(err => {
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        getMomentId(event) {
            var momentCardInnerElement = event.target.closest('.moment-card-inner');
            if (momentCardInnerElement) {
                var dataId = momentCardInnerElement.getAttribute('data-id');
                return dataId;
            } else {
                return null;
            }
        },
        deleteMoment(){
            if(!confirm('确定要删除这个帖子吗？')) return

            //closest方法来获取最接近的具有指定类的父元素。closest方法会向上遍历DOM树，直到找到符合条件的元素为止
            var parentElement = event.target.closest('.moment-item')
            
            let post_id = this.getMomentId(event)
            
            this.$http.post(qk_rest_url + 'deleteMoment','post_id='+post_id).then(res=>{
                this.$message({ message: res.data.message , type: 'success' });
                if (parentElement) {
                    parentElement.remove();
                }
            }).catch(err => {
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        changeMomentStatus(){
            var parentElement = event.target.closest('.moment-card-inner')
            let pending = parentElement.querySelector('span .pending');
            
            let post_id = this.getMomentId(event)
            
            this.$http.post(qk_rest_url + 'changeMomentStatus','post_id='+post_id).then(res=>{
                this.$message({ message: '审核成功' , type: 'success' });
                if (pending) {
                    pending.remove();
                }
            }).catch(err => {
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
    }
};
